import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Menu, Dropdown, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGridHorizontal } from '@fortawesome/pro-solid-svg-icons/faGridHorizontal'
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen'
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons/faEllipsisV'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { ICollection } from 'interfaces/learningPath'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { slices } from 'store/slices'
import { Wrapper, Header, Title, Content } from './styled'
import Courses from './courses'
import { DraggableProvided } from 'react-beautiful-dnd'

interface IProps {
  collection: ICollection
  provided: DraggableProvided
}

const Collection = ({ collection, provided }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'administration.learningPaths.manage.create.content.collections'
  const dispatch = useAppDispatch()
  const [isOpen, setIsOpen] = useState(true)
  const [isChangingTitle, setIsChangingTitle] = useState(false)
  const content = useAppSelector(slices.learningPath.content)

  const onBlur = () => {
    setIsChangingTitle(false)
    dispatch(slices.learningPath.validateCollectionName(collection.order))
  }

  return (
    <Wrapper>
      <Header>
        <Button type="link" {...provided.dragHandleProps}>
          <FontAwesomeIcon icon={faGridHorizontal} />
        </Button>
        {isChangingTitle ? (
          <Input
            value={collection.name}
            onBlur={onBlur}
            autoFocus={true}
            onChange={(event: { target: { value: string } }) =>
              dispatch(
                slices.learningPath.changeCollectionName({
                  collectionOrder: collection.order,
                  collectionName: event.target.value,
                })
              )
            }
          />
        ) : (
          <Title onClick={() => setIsChangingTitle(true)}>
            {collection.name}
          </Title>
        )}
        <Button onClick={() => setIsChangingTitle(true)} type="link">
          <FontAwesomeIcon icon={faPen} />
        </Button>
        <Button type="link" onClick={() => setIsOpen(!isOpen)}>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </Button>
        <Dropdown
          disabled={content.collections.length === 1}
          overlay={
            <Menu>
              <Menu.Item
                onClick={() =>
                  dispatch(
                    slices.learningPath.removeCollection(collection.order)
                  )
                }
              >
                {t(`${prefix}.buttons.remove`)}
              </Menu.Item>
            </Menu>
          }
        >
          <Button type="link">
            <FontAwesomeIcon icon={faEllipsisV} />
          </Button>
        </Dropdown>
      </Header>
      <Content open={isOpen}>
        <Courses collection={collection} />
      </Content>
    </Wrapper>
  )
}

export default Collection
